import Modal from "../components/Modal";
import { useState } from "react";
import { GetInTouch } from "../components/GetInTouch";
import {
  TRANSIT_COURIER_DOUBLE_CAB_IN_VAN_COLLECTION,
  TRANSIT_COURIER_DOUBLE_CAB_IN_VAN_MODEL,
} from "../constants/transitCourierDoubleCabInVan";

export default function TransitCourierDoubleCabInVan() {
  const model = TRANSIT_COURIER_DOUBLE_CAB_IN_VAN_MODEL;
  const copy = "raya.dacheva@motopfohe.bg";
  const conversionSendTo = "AW-17814485194/HOcACLil1d0bEMrxza5C";
  document.title = "Ford Courier";

  const [showModal, setShowModal] = useState(false);
  const [zapitvane, setZapitvane] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    setZapitvane(false);
  };

  return (
    <div className="font-fordAntennaRegular">
      <section className="relative">
        <img
          src="../images/transit-courier/ford-courier-desktop.jpg"
          alt="Ford Courier"
          className="hidden w-full lg:block"
        />
        <img
          src="../images/transit-courier/ford-courier-mobile.jpg"
          alt="Ford Courier"
          className="block w-full lg:hidden"
        />
        <div className="absolute inset-x-0 bottom-0 flex justify-center p-6 text-center lg:inset-x-auto lg:bottom-auto lg:left-4 lg:top-4 lg:max-w-xl lg:justify-start lg:p-0 lg:text-left">
          <div className="rounded-2xl bg-black/45 px-5 py-4 text-white backdrop-blur-[2px] lg:px-6 lg:py-5">
            <p className="text-sm tracking-wider uppercase font-fordMedium lg:text-lg">
              Ford Courier
            </p>
            <h1 className="mt-3 text-xl leading-[1.05] uppercase font-fordBlack lg:text-4xl">
              Сега на ексклузивна цена
              <br />
              <span className="text-lg">от</span> 17 890{" "}
              <span className="text-2xl">€</span> / 34 989,79{" "}
              <span className="text-2xl">лв.</span>
              <br />
              <span className="block -mt-0.5 text-lg font-fordMedium">
                без ДДС
              </span>
            </h1>
          </div>
        </div>
      </section>
      <section className="p-4 lg:p-12 lg:px-36">
        <p className="mt-8 text-2xl leading-8 tracking-wide text-center lg:text-5xl font-fordBlack text-fordBlue">
          FORD COURIER
        </p>
        <p className="mt-4 text-2xl leading-8 tracking-wide text-center text-fordBlue">
          Максимална практичност за бизнеса с 4+1 места и функционално товарно
          пространство.
        </p>
        <div className="flex flex-col items-center justify-center gap-8 mt-8 lg:gap-12 lg:flex-row">
          <button
            className="px-12 py-2 border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white"
            onClick={() => {
              setShowModal(true);
              setZapitvane(true);
              window.scrollTo(0, 0);
            }}
          >
            Свържи се с търговец
          </button>
          <a href="https://sale.ford.bg/?model=Courier" rel="noreferrer">
            <button className="px-12 py-2 border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white">
              Налични автомобили
            </button>
          </a>
        </div>
      </section>
      <section className="p-8 lg:p-12 lg:px-64 bg-fordBlue">
        <p className="text-lg text-center text-white">
          Ford Courier съчетава практичност, комфорт и високо ниво на
          безопасност. Стандартното оборудване включва климатик,
          мултифункционален волан, 8-инчов мултимедиен екран със SYNC 4 и
          каучуково покритие на товарното отделение. За спокойствие на пътя
          моделът разполага с 6 въздушни възглавници, включително странични
          завеси, система за поддържане на лентата и система за разпознаване на
          пътни знаци.
        </p>
      </section>
      <section>
        <div className="flex flex-col mx-4 my-16 lg:m-16 lg:flex-row">
          <img
            src="../images/transit-courier/loading-volume.jpg"
            alt=""
            className="rounded-xl lg:w-1/2"
          />
          <div className="p-4 lg:p-16 lg:w-1/2">
            <h3 className="text-5xl tracking-wide text-fordBlue">Oбем</h3>
            <p className="mt-4 text-md text-fordBlue">
              Ford Courier 4+1 места съчетава комфорт за пътниците с впечатляващ
              товарен капацитет. При сгъване на седалките от втория ред
              багажното пространство достига до 2450 литра, което позволява
              превоз на обемисти товари и оборудване. Ширината между арките е
              1,22 м, осигурявайки достатъчно място за удобно товарене на
              по-широки товари. С товароносимост до 718 кг, Courier е надеждно
              решение за ежедневни доставки и за професионални дейности, при
              които са необходими простор, здравина и практичност.
            </p>
          </div>
        </div>
        <div className="flex flex-col-reverse mx-4 lg:mx-16 lg:flex-row">
          <div className="p-4 lg:p-16 lg:w-1/2 ">
            <h3 className="text-5xl tracking-wide text-fordBlue">Свързаност</h3>
            <p className="mt-4 text-md text-fordBlue">
              Ford Courier е оборудван с най-новата система SYNC 4 с 8" сензорен
              екран, изцяло свързан с мобилно устройство, системи за подпомагане
              на водача и информация за състоянието на автомобила.
            </p>
          </div>
          <img
            src="../images/new-transit-courier/ford-transit-courier-connectivity.jpg"
            alt=""
            className="lg:w-1/2 rounded-xl"
          />
        </div>
        <div className="flex flex-col mx-4 mt-16 lg:m-16 lg:flex-row">
          <img
            src="../images/transit-courier/Transit_Courier_Cactus_Grey_Interior.webp"
            alt=""
            className="lg:w-1/2 rounded-xl"
          />
          <div className="p-4 lg:p-16 lg:w-1/2 bg-gray-50">
            <h3 className="text-5xl tracking-wide text-fordBlue">
              Помощ при управление
            </h3>
            <p className="mt-4 text-md text-fordBlue">
              Ford Courier е снабден с усъвършенствани системи, които ви помагат
              в работния ден. Интелигентните системи за подпомагане на
              шофирането, включително поддържане на лентата за движение,
              асистент за предотвратяване на сблъсък и интелигентен асистент за
              намаляване на скоростта, правят шофирането и работата по-лесни,
              по-интелигентни и по-безопасни.
            </p>
          </div>
        </div>
      </section>
      <section className="flex flex-col items-center px-4 py-12 lg:justify-center lg:p-16 lg:flex-row">
        <a
          href="https://ford.bg/commercial_cars/new-transit-courier"
          target="_blank"
          rel="noreferrer"
        >
          <button className="px-12 py-2 mx-8 border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white">
            Виж повече за модела
          </button>
        </a>
        <button
          className="px-12 py-2 mx-8 mt-8 border rounded-full lg:mt-auto border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white"
          onClick={() => {
            setShowModal(true);
            setZapitvane(true);
            window.scrollTo(0, 0);
          }}
        >
          Свържи се с търговец
        </button>
      </section>
      <section className="p-4 -mb-8 lg:px-24">
        <p className="text-sm text-gray-500">
          * Офертата се отнася за Ford Transit Courier DCiV с 4+1 места N1 с
          право на данъчен кредит. Посочената специална цена е предназначена за
          бизнес клиенти и е валидна до изчерпване на количествата.
          Изображението е с илюстративна цел.
        </p>
      </section>
      {showModal && zapitvane && (
        <Modal handleClose={handleClose}>
          <GetInTouch
            model={model}
            copy={copy}
            conversionSendTo={conversionSendTo}
            collectionName={TRANSIT_COURIER_DOUBLE_CAB_IN_VAN_COLLECTION}
          />
        </Modal>
      )}
    </div>
  );
}
